import { render, staticRenderFns } from "./ProjectDescription.vue?vue&type=template&id=4cd105a6&scoped=true&"
import script from "./ProjectDescription.vue?vue&type=script&lang=js&"
export * from "./ProjectDescription.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDescription.vue?vue&type=style&index=0&id=4cd105a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd105a6",
  null
  
)

export default component.exports